import { Select, Stack, Text } from '@mantine/core'
import { useVersionContext } from '@/context/VersionContext'

export function VersionSwitcher() {
  const {
    versions,
    selectedVersion,
    setSelectedVersion,
    isLoading,
  } = useVersionContext()

  if (versions.length === 0 && !isLoading) return null

  const formatLabel = (version: string, isCurrent?: boolean) => {
    const name = version === 'pre-versioning' ? 'Pre-versioning' : version
    return isCurrent ? `${name} (current)` : name
  }

  const options = versions.map(v => ({
    value: v.version,
    label: formatLabel(v.version, v.isCurrent),
  }))

  return (
    <Stack gap={4} px="sm" mb="sm">
      <Text size="xs" fw={600} c="dimmed" tt="uppercase">
        Version
      </Text>
      <Select
        size="xs"
        placeholder="Select version"
        data={options}
        value={selectedVersion}
        onChange={setSelectedVersion}
        disabled={isLoading}
      />
    </Stack>
  )
}
